import { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/pickup/pickup-shipping-product-list.module.css';

export const BackToSubscriptionTop: FC = () => {
  return (
    <Link to="/" className={classes.backLink}>
      戻る
    </Link>
  );
};
